<kendo-dialog *ngIf="editFormActive" (close)="closeEditForm()" [width]="750">
    <kendo-dialog-titlebar>
        <h3>{{ (isNew ? 'ADD-NOTICE' : 'EDIT-NOTICE') | translate }}</h3>
    </kendo-dialog-titlebar>
    <form novalidate [formGroup]="editForm" class="k-form">
        <div class="row">
            <div class="col-12">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'NOTICE-TEXT' | translate}} *
                    </span>
                    <textarea id="text" kendoTextArea class="w-100" cols="120" rows="3" formControlName="text"
                        maxlength="255">
                    </textarea>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="text.hasError('required') && text.touched">
                        {{'REQUIRED-NOTICE' | translate}}
                    </div>
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-4">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'START-DATE' | translate}} *
                    </span>
                    <kendo-datetimepicker class="w-100" formControlName="startOn"></kendo-datetimepicker>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="startOn.hasError('required') && startOn.touched">
                        {{'START-DATE-REQUIRED' | translate}}
                    </div>
                </label>
            </div>
            <div class="col-4">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'END-DATE' | translate}} *
                    </span>
                    <kendo-datetimepicker class="w-100" formControlName="endOn"></kendo-datetimepicker>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="endOn.hasError('required') && endOn.touched">
                        {{'END-DATE-REQUIRED' | translate}}
                    </div>
                </label>
            </div>
            <div class="col-4">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'NOTICE-PRIORITY' | translate}} *
                    </span>
                    <kendo-combobox id="priority" formControlName="priority" [data]="noticePriorities"
                        [textField]="'displayName'" [valueField]="'id'" class="w-100" [valuePrimitive]="true">
                    </kendo-combobox>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="priority.hasError('required') && priority.touched">
                        {{ 'NOTICE-PRIORITY-REQUIRED' | translate }}
                    </div>
                </label>
            </div>
        </div>
        <div class="row pt-2">
            <div class="col-4">
                <label class="k-text-uppercase dark mr-2" for="canDismiss">{{ 'NOTICE-CAN-DISMISS' | translate
                    }}</label>
                <kendo-switch formControlName="canDismiss" onLabel="{{'YES' | translate }}"
                    offLabel="{{'NO' | translate }}">
                </kendo-switch>
            </div>
            <div class="col-4">
                <label class="k-text-uppercase dark mr-2" for="active">{{ 'ENABLED' | translate }}</label>
                <kendo-switch formControlName="active" onLabel="{{'YES' | translate }}"
                    offLabel="{{'NO' | translate }}">
                </kendo-switch>
            </div>
        </div>
    </form>
    <div>* {{'REQUIRED-FIELDS' | translate}}</div>
    <kendo-dialog-actions>
        <button class="k-button" (click)="onCancel($event)">{{ 'CANCEL' | translate }}</button>
        <button appPreventClick class="k-button k-primary" [disabled]="!editForm.valid || !editForm.dirty"
            (click)="onSave($event)">{{ 'SAVE' | translate }}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>